import { render } from "./checkbox_icon.vue?vue&type=template&id=736e1e73&lang=pug"
import script from "./checkbox_icon.vue?vue&type=script&lang=js"
export * from "./checkbox_icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__